import { useMutation, useQueryClient } from "@tanstack/react-query";
import { t } from "ttag";

import { billingQueriesStore } from "@/features/billing/api";
import {
  subscriptionsQueries,
  upgradeSubscription,
} from "@/features/subscriptions/services";
import { errorToast, useToastStore } from "@/shared/ui";

export const useUpgradeSubscription = () => {
  const { pushToast } = useToastStore();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: upgradeSubscription,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: billingQueriesStore.subscriptions.queryKey,
      });
      void queryClient.invalidateQueries({
        queryKey: subscriptionsQueries.detail().queryKey,
      });

      void pushToast({
        type: "success",
        title: t`Success`,
        message: t`Subscription plan successfully upgraded!`,
      });
    },
    onError: errorToast,
  });
};
